import { CATEGORY } from "../util/enum";

export const ROUTER_PATHS = {
    ADD_PART2: "addpart2",
    ADD_PART2_INFO: "addpart2Info",
    ADD_PART2_SUBSCRIPTION_INFO: "/userlogin/subscription/addpart2Info",
    AddPart2Main: "/userlogin/subscription/addpart2",
    review: "addPart2Review",
    success: "addPart2Success",
    ADD_PART2_REVIEW: "/userlogin/subscription/addPart2Review",
    ADD_PART2_SUCCESS: "/userlogin/subscription/addPart2Success",
    Modify: "modify",
    ModifyMain: "/userlogin/subscription/modify",
    MODIFY_INFO: "modifyInfo",
    MODIFY_SUBSCRIPTION_INFO: "/userlogin/subscription/modifyInfo",
    modifyReview: "modifyReview",
    modifySuccess: "modifySuccess",
    MODIFY_REVIEW: "/userlogin/subscription/modifyReview",
    MODIFY_SUCCESS: "/userlogin/subscription/modifySuccess",
    Active: "active",
    ActiveMain: "/userlogin/subscription/active",
    Active_INFO: "activeInfo",
    Active_SUBSCRIPTION_INFO: "/userlogin/subscription/activeInfo",
    activeReview: "activeReview",
    activeSuccess: "activeSuccess",
    Active_REVIEW: "/userlogin/subscription/activeReview",
    Active_SUCCESS: "/userlogin/subscription/activeSuccess",
    Exception: "exception",
    ExceptionMain: "/userlogin/subscription/exception",
    Exception_INFO: "exceptionInfo",
    Exception_SUBSCRIPTION_INFO: "/userlogin/subscription/exceptionInfo",
    ExceptionReview: "exceptionReview",
    ExceptionSuccess: "exceptionSuccess",
    Exception_REVIEW: "/userlogin/subscription/exceptionReview",
    Exception_SUCCESS: "/userlogin/subscription/exceptionSuccess",
    Expire: "expire",
    ExpireMain: "/userlogin/subscription/expire",
    ExpireReview: "expireReview",
    Expire_REVIEW: "/userlogin/subscription/expireReview",
    GlobalSearch:"/globalSearch",
    GlobalSearchMain:"/userlogin/subscription/globalSearch"

}
export const FIELDS_LEFT_TOP_START = 0;
export const FIELDS_LEFT_TOP_END = 2;
export const FIELDS_LEFT_BOTTOM_END = 4;
export const FIELDS_RIGHT_TOP_END = 7;
export const FIELDS_RIGHT_BOTTOM_END = 11;
export const CATEGORY_CONFIG = [
    { key: 'loadChartValues', label: 'selectcharts', category: CATEGORY.CHARTS },
    { key: 'navigationValues', label: 'navigation', category: CATEGORY.NAVIGATION },
    { key: 'threatValues', label: 'threat', category: CATEGORY.THREAT },
    { key: 'amdbValues', label: 'amdb', category: CATEGORY.AMDB },
    { key: 'epicTerrainValues', label: 'epicTerrain', category: CATEGORY.EPIC_TERRAIN },
    { key: 'peafTerrainValues', label: 'peafTerrain', category: CATEGORY.PEAF_TERRAIN },
];
export const searchOptions = ["ACCOUNTNUMBER", "MAKE", "MODEL", "SERIAL NUMBER", "TAIL NUMBER", "BOM TYPE"];
export const chartCoverageInfo = "Charting Coverage";
export const dataCoverageInfo = "Data Only Coverage";
export const searchOptions1 = [
  { id: "ACCOUNT_NUMBER", label: "Account Number", value: "ACCOUNT_NUMBER" },
  { id: "MAKE", label: "Make", value: "MAKE" },
  { id: "MODEL", label: "Model", value: "MODEL" },
  { id: "SERIAL_NUMBER", label: "Serial Number", value: "SERIAL_NUMBER" },
  { id: "TAIL_NUMBER", label: "Tail Number", value: "TAIL_NUMBER" },
  { id: "BOM_TYPE", label: "BOM Type", value: "BOM_TYPE" }
];
export const globalSearchOptions = [
  { id: "ACCOUNT_NUMBER", label: "Account Number", value: "ACCOUNT_NUMBER" },
  { id: "SERIAL_NUMBER", label: "Serial Number", value: "SERIAL_NUMBER" },
  { id: "TAIL_NUMBER", label: "Tail Number", value: "TAIL_NUMBER" },
];
export const fieldMap: Record<string, string> = {
    "ACCOUNT_NUMBER": "customerNumber",
    "MAKE": "aircraftMake",
    "MODEL": "aircraftModel",
    "SERIAL NUMBER": "serialNumber",
    "TAIL NUMBER": "tailNumber",
    "BOM TYPE": "oldNewOrg"
};
export const autoPopulateMap: Record<string, string> = {
    ACCOUNT_NUMBER: "accountNumberList",
    MAKE: "aircraftMakeList",
    MODEL: "aircraftModelList",
    SERIAL_NUMBER: "serialNumberList",
    TAIL_NUMBER: "tailNumberList",
    BOM_TYPE: "bomTypeList"
};
export const columnHeader = [
  { id: "updatedOn", label: "Updated On" },
  { id: "updatedBy", label: "Updated By" },
  { id: "part1Details", label: "Part 1 Details" },
  { id: "coverages", label: "List of Products" },
];